<script>
  import Icon from '$lib/components/Icon.svelte';
  import { twMerge } from 'tailwind-merge';

  /**
   * @typedef {Object} Props
   * @property {any} icon
   * @property {boolean} [active]
   * @property {string} [href]
   * @property {any} [badge]
   * @property {string} [title]
   * @property {boolean} [expanded]
   */

  /** @type {Props} */
  let {
    icon,
    active = false,
    href = '/',
    badge = null,
    title = '',
    expanded = true,
  } = $props();

  let classes = $derived(
    twMerge([
      'relative block flex items-center p-2 justify-center rounded transition dark:hover:text-white hover:bg-gray-2 dark:hover:bg-gray-7',
      active && 'bg-gray-2 dark:bg-gray-7 text-gray-8 dark:text-white',
      expanded && 'justify-between',
    ]),
  );

  let badgeClass = $derived(
    twMerge([
      'p-px px-1  bg-yellow text-black rounded-full font-mono text-xs leading-none',
      !expanded && 'absolute top-1 right-1',
    ]),
  );
</script>

<a {href} class={classes} {title}>
  <div class="flex items-center gap-1 overflow-hidden">
    <Icon size="lg" {icon} />
    {#if expanded}
      <span class="ml-2 whitespace-nowrap pt-0.5">{title}</span>
    {/if}
  </div>
  {#if badge}
    <div class={badgeClass}>
      {badge}
    </div>
  {/if}
</a>
